import { createFetchedData, LoadingState } from '@vista-digital/utilities';
export const defaultTemporaryOrderDomainState = {
    inProgressActions: new Map(),
    inProgressItems: [],
    payments: {
        currentRedirectPayment: createFetchedData(LoadingState.NotLoaded),
        maximumMemberBalancePayment: undefined
    }
};
//# sourceMappingURL=state.js.map